import React from "react";
import Link from "next/link";
import { AwardTrustMarker } from "@interfaces/trust-markers.types";
import styles from "./AckoDriveAwards.module.scss";
import Image from "next/image";
import { ACKODRIVE_AWARDS_URL } from "@helpers/trustMarkerSlugHelper";
import assetLoader from "@utils/internalImageLoder";
import { parseAwardTagName } from "@helpers/awardDisplayHelper";

export interface AckoDriveAwardsProps {
  awards: AwardTrustMarker[];
  className?: string;
  showViewAll?: boolean;
  isInApp?: boolean;
}

const AckoDriveAwards: React.FC<AckoDriveAwardsProps> = ({
  awards,
  className = "",
  showViewAll = false,
  isInApp
}) => {
  if (!awards || awards.length === 0) {
    return null;
  }

  const displayAwards = showViewAll ? awards.slice(0, 4) : awards;

  const rootClassName = `${styles.ackoDriveAwards} ${className}`;

  const content = (
    <>
      <div className={styles.header}>
        <h3 className={styles.title}>ACKO Drive awards</h3>
        {showViewAll && awards.length > 2 && (
          <div className={styles.viewAllButton} aria-label="View all awards">
            <Image
              src={`${assetLoader()}/icons/Carousal/ArrowRight.svg`}
              alt="View all"
              width={24}
              height={24}
            />
          </div>
        )}
      </div>

      <div className={styles.awardsList}>
        {displayAwards.map((award, index) => {
          const { awardType, category } = parseAwardTagName(award.tagName);
          return (
            <div
              key={`${award.tagName}-${award.awardYear}-${index}`}
              className={styles.awardCard}
            >
              <div className={styles.logoWrapper}>
                <Image
                  src={award.logoUrl}
                  alt={`${award.tagName} ${award.awardYear}`}
                  width={48}
                  height={48}
                  className={styles.logo}
                />
              </div>
              <div className={styles.awardInfo}>
                <p className={styles.year}>
                  {awardType} {award.awardYear}
                </p>
                <p className={styles.category}>{category}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  if (isInApp) {
    return (
      <div className={rootClassName}>
        {content}
      </div>
    );
  }

  return (
    <Link href={ACKODRIVE_AWARDS_URL} className={rootClassName}>
      {content}
    </Link>
  );
};

export default AckoDriveAwards;
